export function formatItemDisplayName(productLike, itemNameFormat = 'name_sku') {
  const name = productLike?.name || (typeof productLike === 'string' ? productLike : 'Item');
  const sku = productLike?.sku;
  const brand = productLike?.brand;
  const description = productLike?.description;

  switch (itemNameFormat) {
    case 'name':
      return name;
    case 'name_sku':
      return sku ? `${name} (${sku})` : name;
    case 'name_brand':
      return brand ? `${name} - ${brand}` : name;
    case 'name_brand_sku':
      if (brand && sku) return `${name} - ${brand} (${sku})`;
      if (brand) return `${name} - ${brand}`;
      if (sku) return `${name} (${sku})`;
      return name;
    case 'brand_name':
      return brand ? `${brand} - ${name}` : name;
    case 'brand_name_sku':
      if (brand && sku) return `${brand} - ${name} (${sku})`;
      if (brand) return `${brand} - ${name}`;
      if (sku) return `${name} (${sku})`;
      return name;
    case 'name_desc':
      return description ? `${name} - ${description}` : name;
    case 'name_desc_sku':
      if (description && sku) return `${name} - ${description} (${sku})`;
      if (description) return `${name} - ${description}`;
      if (sku) return `${name} (${sku})`;
      return name;
    case 'name_brand_desc': {
      const parts = [name, brand, description].filter(Boolean);
      return parts.join(' - ');
    }
    case 'name_brand_desc_sku': {
      const parts = [name, brand, description].filter(Boolean);
      const text = parts.join(' - ');
      return sku ? `${text} (${sku})` : text;
    }
    case 'desc':
      return description || name;
    case 'desc_sku':
      return description ? (sku ? `${description} (${sku})` : description) : (sku ? `${name} (${sku})` : name);
    case 'desc_name':
      return description ? `${description} - ${name}` : name;
    default:
      return sku ? `${name} (${sku})` : name;
  }
}
